// サーバから応答が無い ERR_NETWORK を判定する（オフライン・電波断など）。
// `response` を持つ場合（サーバが応答した上でのエラー）は対象外とし、
// タイムアウト（ECONNABORTED / ETIMEDOUT）は障害検知のため除外せず、中断とも区別する。
export const isResponselessNetworkError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  if ("response" in error && (error as { response?: unknown }).response !== undefined) return false;
  const code = (error as { code?: unknown }).code;
  return code === "ERR_NETWORK";
};
